import React from "react";
import { useI18n } from "../i18n";
import { ShieldCheck, Infinity as InfinityIcon, Plane, FileCheck2 } from "lucide-react";

/**
 * Inline strip of trust badges:
 * - Brazilian driver license accepted (huge for Everett's Brazilian community)
 * - Unlimited mileage
 * - Insurance included
 * - Airport pickup
 */
const TrustBadges = ({ compact = false }) => {
  const { lang } = useI18n();
  const isPt = lang === "pt";

  const badges = [
    {
      icon: FileCheck2,
      title: isPt ? "CNH brasileira aceita" : "Brazilian license accepted",
      sub: isPt
        ? "Válida por 1 ano nos EUA — sem IDP"
        : "Valid for 1 year in the US — no IDP required",
      featured: true,
    },
    {
      icon: InfinityIcon,
      title: isPt ? "Milhas livres" : "Unlimited miles",
      sub: isPt ? "Em todos os carros" : "On every car",
    },
    {
      icon: ShieldCheck,
      title: isPt ? "Seguro incluso" : "Insurance included",
      sub: isPt ? "Sem taxa surpresa" : "No surprise fees",
    },
    {
      icon: Plane,
      title: isPt ? "Entrega no Logan" : "Logan Airport delivery",
      sub: isPt ? "Te buscamos no terminal" : "We meet you at arrivals",
    },
  ];

  if (compact) {
    return (
      <div
        className="flex flex-wrap items-center gap-x-6 gap-y-3 text-xs font-mono-ui uppercase tracking-widest"
        data-testid="trust-badges-compact"
      >
        {badges.map((b, i) => (
          <span
            key={i}
            className={`flex items-center gap-2 ${
              b.featured ? "text-[#FFB400]" : "text-zinc-400"
            }`}
          >
            <b.icon size={14} /> {b.title}
          </span>
        ))}
      </div>
    );
  }

  return (
    <div
      className="grid grid-cols-2 md:grid-cols-4 gap-px bg-white/10 border border-white/10"
      data-testid="trust-badges"
    >
      {badges.map((b, i) => (
        <div
          key={i}
          className={`p-6 ${
            b.featured ? "bg-[#FFB400] text-[#0a0a0a]" : "bg-[#0a0a0a] text-white"
          }`}
          data-testid={`trust-badge-${i}`}
        >
          <b.icon size={22} className={b.featured ? "text-[#0a0a0a]" : "text-[#FFB400]"} />
          <p
            className={`mt-3 font-heading text-base font-semibold leading-tight ${
              b.featured ? "text-[#0a0a0a]" : "text-white"
            }`}
          >
            {b.title}
          </p>
          <p
            className={`mt-1 text-xs ${
              b.featured ? "text-[#0a0a0a]/70" : "text-zinc-500"
            }`}
          >
            {b.sub}
          </p>
        </div>
      ))}
    </div>
  );
};

export default TrustBadges;
